import styled from "styled-components";

export const BrokerPortfolioListArea = styled.div`
  margin: 12px 0 20px;
`;

export const BrokerPortfolioButtonArea = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  & > button {
    width: 100%;
  }
`;

export const NoDataText = styled.div`
  color: #3c587c;
  text-align: center;
  padding: 20px 0px;
`;
